import React, { Component } from "react";
import { func, string, array } from "prop-types";
import CheckboxContainer from "../../../../common/checkbox/CheckboxContainer.js";

class UsersBlock extends Component {
  static propTypes = {
    budget: string,
    onCheckboxChange: func,
    data: array,
    checkAgainst: array
  };

  render() {
    if (!this.props.data) {
      return null;
    } else {
      const data = this.props.data.map(u => ({
        display_name: u.first_name + " " + u.last_name,
        value: u.id,
        thumbnail: u.profile_photo_url
      }));

      const checkAgainst = this.props.checkAgainst.map(u => ({ value: u }));

      return (
        <div className="donor-selector">
          <CheckboxContainer
            title="Select Project Members"
            name="users"
            thumbnails={true}
            onCheckboxChange={this.props.onCheckboxChange}
            checkboxData={data}
            checkAgainst={checkAgainst}
          />
        </div>
      );
    }
  }
}

export default UsersBlock;



// WEBPACK FOOTER //
// ./src/components/main/projects/_form-blocks/UsersBlock.js